(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-shortcuts"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-mk-cshortcuts]').forEach(function (wrapper) {
      var viewport = wrapper.querySelector('.mk-cshortcuts__viewport');
      var prev = wrapper.querySelector('.mk-cshortcuts__arrow--prev');
      var next = wrapper.querySelector('.mk-cshortcuts__arrow--next');
      if (!viewport || !prev || !next) return;

      function update() {
        var canScroll = viewport.scrollWidth > viewport.clientWidth + 2;
        if (!canScroll) {
          prev.hidden = true;
          next.hidden = true;
          wrapper.setAttribute('data-at-start', 'true');
          wrapper.setAttribute('data-at-end', 'true');
          return;
        }
        prev.hidden = false;
        next.hidden = false;
        var atStart = viewport.scrollLeft <= 2;
        var atEnd = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 2;
        prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
        next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
        wrapper.setAttribute('data-at-start', atStart ? 'true' : 'false');
        wrapper.setAttribute('data-at-end', atEnd ? 'true' : 'false');
      }

         function step(dir, btn) {
        if (btn && btn.getAttribute('aria-disabled') === 'true') return;
        var amount = viewport.clientWidth;
        viewport.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }

      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      viewport.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);

      // recheck po načítaní obrázkov (ovplyvňuje scrollWidth)
      wrapper.querySelectorAll('img').forEach(function (img) {
        if (img.complete) return;
        img.addEventListener('load', update, { once: true });
        img.addEventListener('error', update, { once: true });
      });

     // forced reset scrollLeft na 0 pri inicializácii (proti scroll-snap driftu)
      function init() {
        viewport.scrollLeft = 0;
        update();
      }
      if (document.readyState === 'complete') {
        init();
      } else {
        window.addEventListener('load', init);
      }
      setTimeout(init, 300);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
